export const iconFontAwesomePunctuationSymbolsMinus = (
	<i className="fa-solid fa-minus"></i>
);
